import React from 'react';
import PropTypes from 'prop-types';
import ConstraintInput from '../constraint-input';
import style from './style.css';
import AdInlineEditForm from '../ad-inline-edit-form';
import DropDownMenu from '../drop-down-menu';
import MenuItem from '../drop-down-menu/menu-item';
import ReactDOM from 'react-dom';

class ConfigurationForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isDropDownMenuOpen: false,
    };

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.toggleDropDownMenu = this.toggleDropDownMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.onDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  render() {
    const {weight, tag, link, image, header, body, button, constraint, onWeightChange, onTagChange,
      onLinkChange, onImageChange, onHeaderChange, onBodyChange, onButtonChange, isSaving, onFileSelect, onDeleteClick,
      imageUrls, filters, onConstraintAdd, onConstraintDelete, simulatedPercentage, configKeys, onConfigKeySelect,
    } = this.props;

    const { isDropDownMenuOpen } = this.state;

    return (
      <div className={ style.container }>
        <DropDownMenu
          ref={element => this.dropDownMenu = element }
          className={ style.dropDownMenu }
          toggle={ this.toggleDropDownMenu }
          isOpen={ isDropDownMenuOpen }
        >
          <MenuItem onClick={ this.createClosingEventListener(onDeleteClick) }>
            Ta bort
          </MenuItem>
          <MenuItem>
            <select
              className={ style.dropDownSelect }
              onChange={ this.createClosingEventListener(onConfigKeySelect) }
              defaultValue="__defaultValue__"
            >
              <option disabled={ true } value="__defaultValue__">Kopiera till</option>
              {
                configKeys.map((configKey, index) => (
                  <option value={ configKey } key={ index }>{ configKey }</option>
                ))
              }
            </select>
          </MenuItem>
        </DropDownMenu>
        <div>
          <label className={ style.label}>Uppskattat genomslag</label>
          <div className={ style.progressBar }>
            {
              simulatedPercentage
                ? (
                  <div className={ style.progressInfo } style={ { width: simulatedPercentage }}>
                    <p className={ style.progressLabel }>{ simulatedPercentage  }</p>
                  </div>
                ) : (
                  <div className={ style.info }>
                    <p className={ style.progressLabel}>Värde saknas</p>
                  </div>
                )
            }

          </div>

          <label className={ style.label}>Innehåll</label>
          <AdInlineEditForm
            image={ image }
            onImageChange={ onImageChange }
            header={ header }
            onHeaderChange={ onHeaderChange }
            body={ body }
            onBodyChange={ onBodyChange }
            link={ link }
            onLinkChange={ onLinkChange }
            button={ button }
            onButtonChange={ onButtonChange }
            onFileSelect={ onFileSelect }
            isDisabled={ isSaving }
            imageUrls={ imageUrls }
          />
          <label className={ style.label }>Märkning
            <input className={ style.input } type="text" value={ tag } onChange={ onTagChange } disabled={ isSaving }/>
          </label>
          <label className={ style.label}>Vikt (1 — 1000)
            <input className={ style.range } type="range" min="1" max="1000" value={ weight } onChange={ onWeightChange } disabled={ isSaving }/>
            <input className={ style.input } type="number" min="1" max="1000" value={ weight } onChange={ onWeightChange } disabled={ isSaving }/>
          </label>
          <label className={ style.label }>Filter</label>
          <ConstraintInput
            value={ constraint }
            filters={ filters }
            onAdd={ onConstraintAdd }
            onDelete={ onConstraintDelete }
            disabled={ isSaving }
          />
        </div>
      </div>
    );
  }

  toggleDropDownMenu(/*event*/) {
    const { isDropDownMenuOpen } = this.state;
    this.setState({
      isDropDownMenuOpen: !isDropDownMenuOpen,
    });
  }

  closeDropDownMenu() {
    this.setState({
      isDropDownMenuOpen: false,
    });
  }

  onDocumentClick(event) {
    // eslint-disable-next-line react/no-find-dom-node
    const dropDownMenuNode = ReactDOM.findDOMNode(this.dropDownMenu);

    if (dropDownMenuNode.contains(event.target)) {
      return;
    }

    this.closeDropDownMenu();
  }

  createClosingEventListener(listener) {
    return (event) => {
      this.closeDropDownMenu();
      listener(event);
    };
  }
}

ConfigurationForm.propTypes = {
  weight: PropTypes.number.isRequired,
  tag: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  constraint: PropTypes.array.isRequired,

  onWeightChange: PropTypes.func.isRequired,
  onTagChange: PropTypes.func.isRequired,
  onLinkChange: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  onHeaderChange: PropTypes.func.isRequired,
  onBodyChange: PropTypes.func.isRequired,
  onButtonChange: PropTypes.func.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,

  imageUrls: PropTypes.array.isRequired,

  isSaving: PropTypes.bool.isRequired,

  filters: PropTypes.object.isRequired,
  onConstraintAdd: PropTypes.func.isRequired,
  onConstraintDelete: PropTypes.func.isRequired,

  simulatedPercentage: PropTypes.string,

  configKeys: PropTypes.array.isRequired,
  onConfigKeySelect: PropTypes.func.isRequired,
};

export default ConfigurationForm;



// WEBPACK FOOTER //
// ./client/src/components/configuration-form/index.js